import React from 'react';
import mime from 'mime';
import Zoom from 'react-medium-image-zoom';

interface Media {
  src: string;
}

const Media = ({ src }: Media) => {
  const type = mime.getType(src);
  const params = { className: 'whatcrm-widget-media__content', src };

  return (
    <div className="whatcrm-widget-media">
      <img className="whatcrm-widget-media__thumbnail" src={src} />

      {type?.startsWith('video') ? (
        <video {...params} controls />
      ) : (
        <Zoom>
          <img {...params} />
        </Zoom>
      )}
    </div>
  );
};

export default Media;
